<script setup lang="ts">
import { RouterView } from 'vue-router'
import { TooltipProvider } from 'reka-ui'
import { Toast } from '@/ui'
import MeasurementConsent from '@/components/consent/MeasurementConsent.vue'
</script>

<template>
  <TooltipProvider
    :delay-duration="300"
    :skip-delay-duration="200"
  >
    <a
      href="#main"
      class="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:rounded-md focus:bg-accent focus:px-3 focus:py-2 focus:text-sm focus:text-accent-ink"
    >
      Zum Inhalt springen
    </a>
    <RouterView />
    <Toast />
    <!--
      Asked once, everywhere — the question belongs to the browser, not to a
      screen, and nothing is loaded or stored until it is answered. See
      `composables/useConsent.ts`.
    -->
    <MeasurementConsent />
  </TooltipProvider>
</template>
